import {
  FermentedVegetableStart,
  FoodCleaning,
  FoodControl,
  FoodControlPointInstance,
  FoodManagementControls,
  FoodProductionControl,
  FoodTemperatureControl,
  FreezingFish,
  Item,
  MaintenanceExam,
  OpenBuffet,
  PestsRevision,
  PestsRounding,
  PicklesPhControl,
  ProgramRevision,
  SushiRice,
  ThermometerVerification,
} from "@enos-monorepo/lib";
import { useMemo } from "react";

import { InventoryControlTexts } from "./TextTypes";
import FermentedVegetablesControlTexts from "./TextTypes/FermentedVegetablesControlTexts";
import { FoodAcceptanceControlTexts } from "./TextTypes/FoodAcceptanceControlTexts";
import { FoodCleaningControlTexts } from "./TextTypes/FoodCleaningControlTexts";
import { FoodProductionControlTexts } from "./TextTypes/FoodProductionControlTexts";
import { FreezingFishControlTexts } from "./TextTypes/FreezingFishControlTexts";
import { MaintenanceExaminationTexts } from "./TextTypes/MaintenanceExamination";
import { OpenBuffetControlTexts } from "./TextTypes/OpenBuffetControlTexts";
import { PestRevisionControlTexts } from "./TextTypes/PestRevisionControlTexts";
import { PestsRoundingControlTexts } from "./TextTypes/PestRoundingControlTexts";
import PicklesPhControlTexts from "./TextTypes/PicklesPhControlTexts";
import { RevisionOfControlsTexts } from "./TextTypes/RevisionOfControlsTexts";
import { SushiRicePhControlTexts } from "./TextTypes/SushiRicePhControlTexts";
import { ThermometerControlTexts } from "./TextTypes/ThermometerControlTexts";

interface InfoTextByTypeProps {
  type?: string;
  controls?: {
    instance: FoodControlPointInstance;
    controlData: FoodControl;
  }[];
  callBack?: () => void;
}

export function InfoTextByType({
  type,
  controls,
  callBack,
}: InfoTextByTypeProps) {
  const texts = useMemo(() => {
    switch (type) {
      case FoodManagementControls.freezer:
      case FoodManagementControls.coldRoom:
      case FoodManagementControls.cooler:
      case FoodManagementControls.fishCooler:
        return (
          <InventoryControlTexts
            datas={
              controls as {
                controlData: FoodTemperatureControl;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
            type={FoodManagementControls[type]}
          />
        );
      case FoodManagementControls.goodsReceipt:
        return (
          <FoodAcceptanceControlTexts
            datas={
              controls as {
                controlData: Item;
                instance: FoodControlPointInstance;
              }[]
            }
          />
        );
      case FoodManagementControls.coolingFood:
      case FoodManagementControls.reheatingFood:
      case FoodManagementControls.heatingTreatment:
      case FoodManagementControls.heatRetetion:
        return (
          <FoodProductionControlTexts
            type={type}
            datas={
              controls as {
                controlData: FoodProductionControl;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.cleaningDishwasher:
      case FoodManagementControls.cleaningFloor:
      case FoodManagementControls.cleaningHood:
        return (
          <FoodCleaningControlTexts
            type={type}
            datas={
              controls as {
                controlData: FoodCleaning;
                instance: FoodControlPointInstance;
              }[]
            }
          />
        );
      case FoodManagementControls.pestsRevision:
        return (
          <PestRevisionControlTexts
            datas={
              controls as {
                controlData: PestsRevision;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.pestsRouding:
        return (
          <PestsRoundingControlTexts
            datas={
              controls as {
                controlData: PestsRounding;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.sushiricepH:
        return (
          <SushiRicePhControlTexts
            datas={
              controls as unknown as {
                controlData: SushiRice;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.openbuffet:
        return (
          <OpenBuffetControlTexts
            datas={
              controls as unknown as {
                controlData: OpenBuffet;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.freezingfish:
        return (
          <FreezingFishControlTexts
            datas={
              controls as unknown as {
                controlData: FreezingFish;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );

      case FoodManagementControls.revisionOfControls:
        return (
          <RevisionOfControlsTexts
            datas={
              controls as {
                controlData: ProgramRevision;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.maintenanceExamination:
        return (
          <MaintenanceExaminationTexts
            datas={
              controls as {
                controlData: MaintenanceExam;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.thermometerVerification:
        return (
          <ThermometerControlTexts
            datas={
              controls as {
                controlData: ThermometerVerification;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      case FoodManagementControls.vegetablespHbeginning:
      case FoodManagementControls.vegetablespHfinal:
      case FoodManagementControls.vegetablespH48Hours:
        return (
          <FermentedVegetablesControlTexts
            datas={
              controls as {
                controlData: FermentedVegetableStart;
                instance: FoodControlPointInstance;
              }[]
            }
            type={type}
            callBack={callBack}
          />
        );
      case FoodManagementControls.picklespH:
        return (
          <PicklesPhControlTexts
            datas={
              controls as {
                controlData: PicklesPhControl;
                instance: FoodControlPointInstance;
              }[]
            }
            callBack={callBack}
          />
        );
      default:
        return;
    }
  }, [callBack, controls, type]);

  return <div>{texts}</div>;
}
